"use strict";
import "lodash";
import { svc_addOne } from "@/services";
import { showServerResponse } from "@/utils/message";

const endpointBasePrefix = "xero/user";

const Model = {
	namespace: "m_XeroUser",
	state: { },
	reducers: { },
	effects: {
		// create autocount connection
		*postConnection({ payload }, { call }) {
			const response = yield call(svc_addOne, `${endpointBasePrefix}/autocount`, payload);
			showServerResponse(response);
			return response;
		},
	},
	subscriptions: { },
};

export default Model;
